import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

export default function MainLayout() {
    // Clear the banking-app session flag so re-entering the demo always starts fresh
    useEffect(() => {
        sessionStorage.removeItem('banking-app-active');
    }, []);

    return (
        <Outlet />
    );
}
